import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function Contact() {
  useSEO({
    title: 'Contact Jeffery Long | eXp Realty Northern California | Real Estate Inquiries',
    description: 'Contact Jeffery Long for all your real estate needs in Northern California. Office in Roseville, CA. Call (916) 257-8244 or email realestatedevelopmentauthority@gmail.com. Serving Sacramento, El Dorado Hills, Cameron Park, and Central Valley. CA DRE #02234432',
    keywords: 'contact realtor, Jeffery Long contact, eXp Realty contact, Sacramento real estate contact, Northern California realtor, real estate inquiries, property questions',
    canonical: '/contact',
    ogTitle: 'Contact Jeffery Long | eXp Realty Northern California',
    ogDescription: 'Get in touch with our real estate professionals. Office in Roseville, CA. Call (916) 257-8244.',
    ogImage: 'https://public.readdy.ai/ai/img_res/8368ea84f8e5c66a941688c5e807e75c.jpg',
    schema: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact Jeffery Long - eXp Realty",
      "description": "Contact page for Jeffery Long real estate services in Northern California.",
      "mainEntity": {
        "@type": "RealEstateAgent",
        "name": "Jeffery Long - eXp Realty",
        "telephone": "+1-916-257-8244",
        "email": "realestatedevelopmentauthority@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "915 Highland Pointe Dr Ste 250",
          "addressLocality": "Roseville",
          "addressRegion": "CA",
          "postalCode": "95678",
          "addressCountry": "US"
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-gray-900 to-gray-700 text-white py-20">
          <div className="absolute inset-0 bg-black/30"></div>
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20real%20estate%20office%20building%20exterior%20with%20professional%20architecture%20and%20clean%20business%20environment&width=1200&height=600&seq=contact-hero&orientation=landscape')`
            }}
          ></div>
          <div className="relative container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Contact Us</h1>
            <p className="text-xl md:text-2xl mb-8">Get in touch with our real estate professionals</p>
            <p className="text-lg">We're here to help with all your real estate needs</p>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Form */}
              <div>
                {/* Newsletter and International Buying Section */}
                <div className="mb-8 space-y-4">
                  <div className="bg-blue-600 rounded-lg p-6 text-white text-center">
                    <h3 className="text-xl font-bold mb-3">Join Our Newsletter & Get Off-Market Access</h3>
                    <p className="mb-4 text-blue-100">Stay updated with exclusive listings and market insights</p>
                    <form 
                      id="newsletter-form"
                      data-readdy-form
                      action="https://readdy.ai/api/form/d4d78h2els5gugpjmkog"
                      method="POST"
                      className="flex flex-col sm:flex-row gap-3"
                      onSubmit={(e) => {
                        e.preventDefault();
                        const form = e.target as HTMLFormElement;
                        const formData = new FormData(form);
                        
                        fetch('https://readdy.ai/api/form/d4d78h2els5gugpjmkog', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                          },
                          body: new URLSearchParams(formData as any).toString()
                        })
                        .then(() => {
                          alert('Successfully subscribed! You will now receive exclusive listings and market updates.');
                          form.reset();
                        })
                        .catch(() => {
                          alert('There was an error with your subscription. Please try again.');
                        });
                      }}
                    >
                      <input 
                        type="email" 
                        name="email"
                        placeholder="Enter your email"
                        required
                        className="flex-1 px-4 py-2 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-300"
                      />
                      <button 
                        type="submit"
                        className="bg-white text-blue-600 px-6 py-2 rounded-md font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
                      >
                        Subscribe Now
                      </button>
                    </form>
                  </div>

                  <div className="bg-green-600 rounded-lg p-6 text-white text-center">
                    <h3 className="text-xl font-bold mb-3">Want to Buy Internationally?</h3>
                    <p className="mb-4 text-green-100">Explore global real estate opportunities</p>
                    <a 
                      href="https://www.exprealty.international/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-white text-green-600 px-6 py-2 rounded-md font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
                    >
                      Explore International Properties
                    </a>
                  </div>
                </div>

                <h2 className="text-3xl font-bold mb-8 text-white">Send Us a Message</h2>
                <form 
                  id="contact-form"
                  data-readdy-form
                  action="https://readdy.ai/api/form/d4d7sgedhknumrhf6e90"
                  method="POST"
                  className="space-y-6"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const form = e.target as HTMLFormElement;
                    const formData = new FormData(form);
                    
                    fetch('https://readdy.ai/api/form/d4d7sgedhknumrhf6e90', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: new URLSearchParams(formData as any).toString()
                    })
                    .then(() => {
                      alert('Message sent successfully! We will get back to you soon.');
                      form.reset();
                    })
                    .catch(() => {
                      alert('There was an error sending your message. Please try again.');
                    });
                  }}
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">First Name</label>
                      <input 
                        type="text" 
                        name="first_name"
                        className="w-full px-4 py-2 border border-gray-600 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                        placeholder="First Name" 
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">Last Name</label>
                      <input 
                        type="text" 
                        name="last_name"
                        className="w-full px-4 py-2 border border-gray-600 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                        placeholder="Last Name" 
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Email</label>
                    <input 
                      type="email" 
                      name="email"
                      className="w-full px-4 py-2 border border-gray-600 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                      placeholder="Email Address" 
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Phone</label>
                    <input 
                      type="tel" 
                      name="phone"
                      className="w-full px-4 py-2 border border-gray-600 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                      placeholder="Phone Number" 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Subject</label>
                    <select 
                      name="subject"
                      className="w-full px-4 py-2 pr-8 border border-gray-600 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Select a subject</option>
                      <option value="buying">Buying a Home</option>
                      <option value="selling">Selling a Home</option>
                      <option value="financing">Financing Questions</option>
                      <option value="commercial">Commercial Properties</option>
                      <option value="off-market">Off-Market Listings</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Message</label>
                    <textarea 
                      rows={6} 
                      name="message"
                      maxLength={500}
                      className="w-full px-4 py-2 border border-gray-600 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                      placeholder="Tell us how we can help you..."
                      required
                    ></textarea>
                  </div>
                  <button 
                    type="submit" 
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md text-lg font-semibold transition-colors whitespace-nowrap"
                  >
                    Send Message
                  </button>
                </form>
              </div>

              {/* Contact Details */}
              <div>
                <h2 className="text-3xl font-bold mb-8 text-white">Get in Touch</h2>
                <div className="space-y-8">
                  {/* Main Office */}
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-4 flex items-center text-white">
                      <i className="ri-building-line mr-2 text-blue-600"></i>
                      Main Office
                    </h3>
                    <address className="not-italic text-gray-300 mb-4">
                      915 Highland Pointe Dr Ste 250<br />
                      Roseville, CA 95678
                    </address>
                    <div className="space-y-2">
                      <a href="tel:916-257-8244" className="flex items-center text-gray-300 hover:text-blue-400 transition-colors">
                        <i className="ri-phone-line mr-2"></i>
                        (916) 257-8244
                      </a>
                      <a href="tel:888-832-7179" className="flex items-center text-gray-300 hover:text-blue-400 transition-colors">
                        <i className="ri-phone-line mr-2"></i>
                        (888) 832-7179
                      </a>
                      <a href="mailto:realestatedevelopmentauthority@gmail.com" className="flex items-center text-gray-300 hover:text-blue-400 transition-colors">
                        <i className="ri-mail-line mr-2"></i>
                        realestatedevelopmentauthority@gmail.com
                      </a>
                    </div>
                  </div>

                  {/* Additional Office */}
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-4 flex items-center">
                      <i className="ri-map-pin-line mr-2 text-blue-600"></i>
                      Additional Location
                    </h3>
                    <address className="not-italic text-gray-700">
                      PO Box 1194<br />
                      Folsom, CA 95763
                    </address>
                  </div>

                  {/* Corporate Headquarters */}
                  <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-600">
                    <h3 className="text-xl font-semibold mb-4" style={{ fontFamily: '"Eurostile Extended", "Arial Black", sans-serif' }}>
                      Corporate Headquarters
                    </h3>
                    <address className="not-italic text-gray-700">
                      725 E Road 2 N Unit 1494<br />
                      Chino Valley, AZ 86323
                    </address>
                  </div>

                  {/* Business Hours */}
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-4 flex items-center">
                      <i className="ri-time-line mr-2 text-blue-600"></i>
                      Business Hours
                    </h3>
                    <div className="space-y-2 text-gray-700">
                      <div className="flex justify-between">
                        <span>Monday - Friday:</span>
                        <span>8:00 AM - 6:00 PM</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Saturday:</span>
                        <span>9:00 AM - 4:00 PM</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Sunday:</span>
                        <span>By Appointment</span>
                      </div>
                    </div>
                  </div>

                  {/* Social Media */}
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-4 flex items-center">
                      <i className="ri-share-line mr-2 text-blue-600"></i>
                      Follow Us
                    </h3>
                    <div className="flex space-x-4">
                      <a href="https://www.facebook.com/profile.php" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                        <i className="fab fa-facebook"></i>
                      </a>
                      <a href="https://www.twitter.com/JeffL_eXpRealty" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-400 text-white rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors">
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a href="https://www.linkedin.com/in/jeffery-long-355a73352/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center hover:bg-blue-800 transition-colors">
                        <i className="fab fa-linkedin"></i>
                      </a>
                      <a href="https://www.youtube.com/@realestatedevelopmentautho3005" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center hover:bg-red-700 transition-colors">
                        <i className="fab fa-youtube"></i>
                      </a>
                      <a href="https://www.instagram.com/jeffery_long_exp_realty0223443/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-pink-600 text-white rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-8">Find Our Office</h2>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3115.8234567890123!2d-121.3012345678901!3d38.7512345678901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDQ1JzA0LjQiTiAxMjHCsDE4JzA0LjQiVw!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Office Location"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Emergency Contact */}
        <section className="py-16 bg-red-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Need Immediate Assistance?</h2>
            <p className="text-xl mb-8">Our team is available for urgent real estate matters</p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
              <a href="tel:916-257-8244" className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                Call Now: (916) 257-8244
              </a>
              <a href="tel:888-832-7179" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition-colors">
                Toll Free: (888) 832-7179
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
